import React from "react";
import { styled } from "@mui/material/styles";
import { Stack, Typography, Rating } from "@mui/material";
import {
  SentimentVeryDissatisfied,
  SentimentDissatisfied,
  SentimentSatisfied,
  SentimentSatisfiedAltOutlined,
  SentimentVerySatisfied,
} from "@mui/icons-material";
import { CUSTOM_ICONS } from "../constants";

const StyledRating = styled(Rating)(({ theme }) => ({
  "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
    color: theme.palette.action.disabled,
  },
}));

const CustomRating = ({ value, onChange, label, helperText }) => {
  // Map icon components
  const iconComponentMap = {
    SentimentVeryDissatisfied,
    SentimentDissatisfied,
    SentimentSatisfied,
    SentimentSatisfiedAltOutlined,
    SentimentVerySatisfied,
  };

  return (
    <Stack direction="column" spacing={1}>
      {label && <Typography gutterBottom>{label}</Typography>}

      <Stack direction="row" spacing={2} alignItems="center">
        <StyledRating
          size="large"
          IconContainerComponent={({ value: ratingValue }) => {
            const iconConfig = CUSTOM_ICONS[ratingValue];
            const IconComponent = iconComponentMap[iconConfig.icon];

            return (
              <span>
                <IconComponent
                  color={
                    ratingValue <= value && value !== 0 ? undefined : "disabled"
                  }
                />
              </span>
            );
          }}
          getLabelText={(ratingValue) => CUSTOM_ICONS[ratingValue].label}
          onChange={(_, newValue) => onChange(newValue || 0)}
          value={value}
        />

        <Typography variant="body1">
          {value > 0
            ? `${value} - ${CUSTOM_ICONS[value].label}`
            : "Not rated yet"}
        </Typography>
      </Stack>

      {helperText && (
        <Typography variant="caption" color="text.secondary">
          {helperText}
        </Typography>
      )}
    </Stack>
  );
};

export default CustomRating;
